import React from 'react';
import { BaseCard } from './BaseCard';
import { FormControl, makeStyles } from '@material-ui/core';
import { BaseInputLabel } from '../BaseTextField/BaseInputLabel/BaseInputLabel';
import { BaseHelperText } from '../BaseTextField/BaseHelperText/BaseHelperText';
import { capitalizeFirstLetter } from '../../../utils/helpers';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  card: {
    padding: '20px',
    [theme.breakpoints.down('sm')]: {
      padding: '10px',
    },
  },
  offCardStyles: {
    padding: '0',
  },
}));

type PBaseCardField = {
  label: string | React.ElementType;
  loading?: boolean;
  errorText?: any;
  cardOptions?: any;
};

export const BaseCardField: React.FC<PBaseCardField> = (props) => {
  const { children, label, loading, errorText, cardOptions = {} } = props;
  const classes = useStyles();
  return (
    <FormControl error={errorText}>
      <BaseInputLabel>{label}</BaseInputLabel>
      <BaseCard
        className={clsx(
          classes.card,
          cardOptions?.offCardStyles && classes.offCardStyles,
        )}
        error={Boolean(errorText)}
        loading={loading}
        {...cardOptions}
      >
        {children}
      </BaseCard>
      {errorText && (
        <BaseHelperText>{capitalizeFirstLetter(errorText)}</BaseHelperText>
      )}
    </FormControl>
  );
};
